import { MdsIconKind } from "@/design-system/components/icon";
import { SourceKind } from "@/store/sources/types";

export const NOTE_SOURCE_ICON_MAP: Record<SourceKind, MdsIconKind> = {
  EMAIL: MdsIconKind.Envelope,
  TEXT_MESSAGE: MdsIconKind.Message,
  UPLOADED_FILE: MdsIconKind.Document,
  API_REQUEST: MdsIconKind.Merge,
  API_REQUEST_VIA_ZAPIER: MdsIconKind.LogoZapier,
  WEB_CLIP: MdsIconKind.Window,
  AUDIO: MdsIconKind.Waveform,
};

export const NOTE_SOURCE_CHIP_ICON_MAP: Record<SourceKind, MdsIconKind> = {
  EMAIL: MdsIconKind.Envelope,
  TEXT_MESSAGE: MdsIconKind.Message,
  UPLOADED_FILE: MdsIconKind.Document,
  API_REQUEST: MdsIconKind.Merge,
  API_REQUEST_VIA_ZAPIER: MdsIconKind.LogoZapierSquare,
  WEB_CLIP: MdsIconKind.Window,
  AUDIO: MdsIconKind.Waveform,
};

export const NOTE_SOURCE_LABEL_MAP: Record<SourceKind, string> = {
  EMAIL: "Email from",
  TEXT_MESSAGE: "Text Messages",
  UPLOADED_FILE: "Uploaded file",
  API_REQUEST: "API Request",
  API_REQUEST_VIA_ZAPIER: "From Zapier",
  WEB_CLIP: "Website",
  AUDIO: "Voice Recording",
};
